import { render, staticRenderFns } from "./CallCenter.vue?vue&type=template&id=1b01ced7&scoped=true"
import script from "./CallCenter.vue?vue&type=script&lang=js"
export * from "./CallCenter.vue?vue&type=script&lang=js"
import style0 from "./CallCenter.vue?vue&type=style&index=0&id=1b01ced7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01ced7",
  null
  
)

export default component.exports